import React from 'react';
import { Modals, ThemeProvider, Toast } from '@ui5/webcomponents-react';
import { AppShellBar } from 'components/shared/AppShellBar';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { CreateQuery } from 'components/CreateQuery';
import { ManageQueries } from 'components/ManageQueries';
import { DisplayQuery } from 'components/DisplayQuery';
import { NotFoundPage } from 'components/shared/ErrorPage/NotFoundPage';
import { AuthorizationGuard } from 'auth/AuthorizationGuard';
import { SwitchRoles } from 'components/SwitchRoles/SwitchRoles';
import { compose } from 'lodash/fp';
import { withTheme } from 'decorators/withTheme';
import { IdleMessageBox } from 'components/shared/IdleMessageBox/IdleMessageBox';
import { UrqlProvider } from 'config/urql/UrqlProvider';
import useGlobalToastMessageStore from 'stores/GlobalToastMessageStore';

const GlobalToast = () => {
  const toastMessage = useGlobalToastMessageStore((state) => state.message);
  const isOpen = useGlobalToastMessageStore((state) => state.isOpen);
  const closeToast = useGlobalToastMessageStore((state) => state.closeToast);

  return (
    <Toast data-testid="global-toast" open={isOpen} onClose={closeToast}>
      {toastMessage}
    </Toast>
  );
};

const App: React.FC = () => {
  return (
    <UrqlProvider>
      <ThemeProvider>
        <Modals />
        <IdleMessageBox />
        <GlobalToast />
        <Router>
          <AppShellBar />
          <AuthorizationGuard>
            <Switch>
              <Route exact path="/">
                <Redirect from="/" to="/queries" />
              </Route>
              <Route exact path="/queries" component={ManageQueries} />
              <Route exact path="/queries/:queryId" component={DisplayQuery} />
              <Route exact path="/create" component={CreateQuery} />
              <Route exact path="/switch-role" component={SwitchRoles} />
              <Route exact path="*" component={NotFoundPage} />
            </Switch>
          </AuthorizationGuard>
        </Router>
      </ThemeProvider>
    </UrqlProvider>
  );
};

export default compose(withTheme)(App);
